import { Alert, Button, Table, message } from "antd"
import React, { useEffect, useState } from "react"
import moment from "moment";

import { Partner } from '../../../constants/partners'
import { Page } from "../../../constants/common";
import Requestor from "../../../requestor";

const Column = Table.Column

const Subsidiary =  () => {

  const [listData, setList] = useState<Page<Partner>>({ page: 1, size: 0, total: 0, payload: [] })

  const getList = async({ page = 1, size = 10}) => {
    const params = { page, size }
    try {
      const res = await Requestor.getpPrtnerSubsidiary<Page<Partner>>(params)
      if (res.error !== '') throw res.error
      setList(res.result)
    } catch(err: any) {
      message.error(err)
    }
  }

  useEffect(() => {
    getList({})
  }, [])

  const onRefresh = () => {
    getList({})
  } 

  return (
    <div>
      <div className="flex-between margin-bottom-16px" >
        <Alert message="您可以查看子企业的业务数据！" type="info" showIcon />
        <Button onClick={() => onRefresh()} type='primary'>刷新</Button>
      </div>
      <Table 
        dataSource={listData.payload}
        pagination={{
          current: listData.page,
          pageSize: listData.size,
          total: listData.total,
          onChange: (page, size) => getList({ page, size }),
          showSizeChanger: true,
          showTotal: (total: number, range: [number, number]) =>
            `共${total}条记录，当前第${range[0]}-${range[1]}条`,
        }}
      >
        <Column title='公司名称' dataIndex='name' />
        <Column title='区域' dataIndex='districtName' />
        <Column 
          title='录入时间' 
          dataIndex='updatedAt' 
          render={val => {
            return <span>{moment(val * 1000).format('YYYY-MM-DD HH:mm')}</span>
          }}
        />
      </Table>
    </div>
  )
}

export default Subsidiary